var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThanksIconBottomRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 386.514,
    height: 349.955,
    viewBox: "0 0 386.514 349.955",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_154",
    "data-name": "Grupo 154",
    transform: "translate(159.396 -1507.173)",
    opacity: 0.08
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_142",
    "data-name": "Grupo 142",
    transform: "translate(-159.396 1507.173)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_141",
    "data-name": "Grupo 141"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_134",
    "data-name": "Grupo 134",
    transform: "translate(0 121.475)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1008",
    "data-name": "Trazado 1008",
    d: "M-112.462,1630.5c-.527,30.847-46.412,30.842-46.934,0C-158.869,1599.65-112.984,1599.655-112.462,1630.5Z",
    transform: "translate(159.396 -1607.364)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1009",
    "data-name": "Trazado 1009",
    d: "M-112.462,1680.594c-.527,30.847-46.412,30.842-46.933,0C-158.869,1649.746-112.984,1649.751-112.462,1680.594Z",
    transform: "translate(159.396 -1596.722)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1010",
    "data-name": "Trazado 1010",
    d: "M-112.462,1730.689c-.527,30.848-46.412,30.843-46.933,0C-158.869,1699.842-112.984,1699.847-112.462,1730.689Z",
    transform: "translate(159.396 -1586.08)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1011",
    "data-name": "Trazado 1011",
    d: "M-112.462,1780.785c-.527,30.846-46.412,30.842-46.933,0C-158.869,1749.938-112.984,1749.943-112.462,1780.785Z",
    transform: "translate(159.396 -1575.438)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_135",
    "data-name": "Grupo 135",
    transform: "translate(56.598 60.738)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1012",
    "data-name": "Trazado 1012",
    d: "M-65.782,1580.4c-.527,30.847-46.412,30.842-46.933,0C-112.189,1549.555-66.3,1549.56-65.782,1580.4Z",
    transform: "translate(112.715 -1557.269)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1013",
    "data-name": "Trazado 1013",
    d: "M-65.782,1630.5c-.527,30.847-46.412,30.842-46.933,0C-112.189,1599.65-66.3,1599.655-65.782,1630.5Z",
    transform: "translate(112.715 -1546.627)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1014",
    "data-name": "Trazado 1014",
    d: "M-65.782,1680.593c-.527,30.848-46.412,30.843-46.933,0C-112.189,1649.746-66.3,1649.751-65.782,1680.593Z",
    transform: "translate(112.715 -1535.985)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1015",
    "data-name": "Trazado 1015",
    d: "M-65.782,1730.689c-.527,30.848-46.412,30.843-46.933,0C-112.189,1699.842-66.3,1699.847-65.782,1730.689Z",
    transform: "translate(112.715 -1525.343)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1016",
    "data-name": "Trazado 1016",
    d: "M-65.782,1780.785c-.527,30.846-46.412,30.842-46.933,0C-112.189,1749.938-66.3,1749.943-65.782,1780.785Z",
    transform: "translate(112.715 -1514.701)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_136",
    "data-name": "Grupo 136",
    transform: "translate(113.194)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1017",
    "data-name": "Trazado 1017",
    d: "M-19.1,1530.306c-.527,30.848-46.412,30.843-46.933,0C-65.509,1499.459-19.624,1499.464-19.1,1530.306Z",
    transform: "translate(66.035 -1507.173)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1018",
    "data-name": "Trazado 1018",
    d: "M-19.1,1580.4c-.526,30.847-46.411,30.842-46.933,0C-65.509,1549.555-19.624,1549.56-19.1,1580.4Z",
    transform: "translate(66.035 -1496.531)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1019",
    "data-name": "Trazado 1019",
    d: "M-19.1,1630.5c-.526,30.847-46.411,30.842-46.933,0C-65.509,1599.65-19.624,1599.655-19.1,1630.5Z",
    transform: "translate(66.035 -1485.889)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1020",
    "data-name": "Trazado 1020",
    d: "M-19.1,1680.593c-.526,30.848-46.411,30.843-46.933,0C-65.509,1649.746-19.624,1649.751-19.1,1680.593Z",
    transform: "translate(66.035 -1475.247)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1021",
    "data-name": "Trazado 1021",
    d: "M-19.1,1730.689c-.526,30.848-46.411,30.843-46.933,0C-65.509,1699.842-19.624,1699.847-19.1,1730.689Z",
    transform: "translate(66.035 -1464.605)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_137",
    "data-name": "Grupo 137",
    transform: "translate(169.79)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1022",
    "data-name": "Trazado 1022",
    d: "M27.578,1530.306c-.526,30.848-46.411,30.843-46.933,0C-18.829,1499.459,27.056,1499.464,27.578,1530.306Z",
    transform: "translate(19.355 -1507.173)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1023",
    "data-name": "Trazado 1023",
    d: "M27.578,1580.4c-.526,30.847-46.411,30.842-46.933,0C-18.829,1549.555,27.056,1549.56,27.578,1580.4Z",
    transform: "translate(19.355 -1496.531)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1024",
    "data-name": "Trazado 1024",
    d: "M27.578,1630.5c-.526,30.847-46.411,30.842-46.933,0C-18.829,1599.65,27.056,1599.655,27.578,1630.5Z",
    transform: "translate(19.355 -1485.889)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1025",
    "data-name": "Trazado 1025",
    d: "M27.578,1680.593c-.526,30.848-46.411,30.843-46.933,0C-18.829,1649.746,27.056,1649.751,27.578,1680.593Z",
    transform: "translate(19.355 -1475.247)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_138",
    "data-name": "Grupo 138",
    transform: "translate(226.386)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1026",
    "data-name": "Trazado 1026",
    d: "M74.258,1530.306c-.526,30.848-46.411,30.843-46.933,0C27.851,1499.459,73.736,1499.464,74.258,1530.306Z",
    transform: "translate(-27.325 -1507.173)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1027",
    "data-name": "Trazado 1027",
    d: "M74.258,1580.4c-.526,30.847-46.411,30.842-46.933,0C27.851,1549.555,73.736,1549.56,74.258,1580.4Z",
    transform: "translate(-27.325 -1496.531)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1028",
    "data-name": "Trazado 1028",
    d: "M74.258,1630.5c-.526,30.847-46.411,30.842-46.933,0C27.851,1599.65,73.736,1599.655,74.258,1630.5Z",
    transform: "translate(-27.325 -1485.889)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1029",
    "data-name": "Trazado 1029",
    d: "M74.258,1680.593c-.526,30.848-46.411,30.843-46.933,0C27.851,1649.746,73.736,1649.751,74.258,1680.593Z",
    transform: "translate(-27.325 -1475.247)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1030",
    "data-name": "Trazado 1030",
    d: "M74.258,1730.689c-.526,30.848-46.411,30.843-46.933,0C27.851,1699.842,73.736,1699.847,74.258,1730.689Z",
    transform: "translate(-27.325 -1464.605)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_139",
    "data-name": "Grupo 139",
    transform: "translate(282.983 60.738)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1031",
    "data-name": "Trazado 1031",
    d: "M120.938,1580.4c-.526,30.847-46.411,30.842-46.933,0C74.532,1549.555,120.417,1549.56,120.938,1580.4Z",
    transform: "translate(-74.005 -1557.269)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1032",
    "data-name": "Trazado 1032",
    d: "M120.938,1630.5c-.526,30.847-46.411,30.842-46.933,0C74.532,1599.65,120.417,1599.655,120.938,1630.5Z",
    transform: "translate(-74.005 -1546.627)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1033",
    "data-name": "Trazado 1033",
    d: "M120.938,1680.593c-.526,30.848-46.411,30.843-46.933,0C74.532,1649.746,120.417,1649.751,120.938,1680.593Z",
    transform: "translate(-74.005 -1535.985)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1034",
    "data-name": "Trazado 1034",
    d: "M120.938,1730.689c-.526,30.848-46.411,30.843-46.933,0C74.532,1699.842,120.417,1699.847,120.938,1730.689Z",
    transform: "translate(-74.005 -1525.343)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1035",
    "data-name": "Trazado 1035",
    d: "M120.938,1780.785c-.526,30.846-46.411,30.842-46.933,0C74.532,1749.938,120.417,1749.943,120.938,1780.785Z",
    transform: "translate(-74.005 -1514.701)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_140",
    "data-name": "Grupo 140",
    transform: "translate(339.579 121.475)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1036",
    "data-name": "Trazado 1036",
    d: "M167.618,1630.5c-.526,30.847-46.411,30.842-46.933,0C121.212,1599.65,167.1,1599.655,167.618,1630.5Z",
    transform: "translate(-120.685 -1607.364)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1037",
    "data-name": "Trazado 1037",
    d: "M167.619,1680.593c-.527,30.848-46.412,30.843-46.934,0C121.212,1649.746,167.1,1649.751,167.619,1680.593Z",
    transform: "translate(-120.685 -1596.722)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1038",
    "data-name": "Trazado 1038",
    d: "M167.619,1730.689c-.527,30.847-46.412,30.843-46.934,0C121.212,1699.842,167.1,1699.847,167.619,1730.689Z",
    transform: "translate(-120.685 -1586.08)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1039",
    "data-name": "Trazado 1039",
    d: "M167.619,1780.785c-.527,30.846-46.412,30.842-46.934,0C121.212,1749.938,167.1,1749.943,167.619,1780.785Z",
    transform: "translate(-120.685 -1575.438)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThanksIconBottomRight);
export default __webpack_public_path__ + "static/media/thanks-icon-bottom-right.1537a7055dc2829542cfaf2008188aeb.svg";
export { ForwardRef as ReactComponent };